module.exports = __webpack_public_path__ + "img/Mango_1.ae1c1217.png";